import script from "./MeetingCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MeetingCard.vue?vue&type=script&setup=true&lang=js"

import "./MeetingCard.vue?vue&type=style&index=0&id=af9688dc&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af9688dc"]])

export default __exports__